import { EXPERIMENT_PACK_SCHEMA_VERSION, STEP_KINDS, STAGE_KINDS, type ExperimentPack } from "./schemas.js";

export interface ValidationResult {
  valid: boolean;
  errors: string[];
}

export function validateExperimentPack(pack: ExperimentPack): ValidationResult {
  const errors: string[] = [];

  if (pack.experiment.schemaVersion !== EXPERIMENT_PACK_SCHEMA_VERSION) {
    errors.push(
      `experiment.schemaVersion 不匹配，期望 ${EXPERIMENT_PACK_SCHEMA_VERSION}，实际 ${pack.experiment.schemaVersion}`,
    );
  }
  if (pack.mission.stages.length === 0) {
    errors.push("mission.stages 不能为空");
  }

  for (const stage of pack.mission.stages) {
    if (stage.kind && !STAGE_KINDS.includes(stage.kind)) {
      errors.push(`stage "${stage.id}" kind 非法：${stage.kind}`);
    }
    if (stage.steps.length === 0) {
      errors.push(`stage "${stage.id}" 没有任何 step`);
      continue;
    }
    for (const step of stage.steps) {
      if (!STEP_KINDS.includes(step.kind)) {
        errors.push(`stage "${stage.id}" step "${step.id}" kind 非法：${step.kind}`);
      }
      const isChoiceKind =
        step.kind === "guess" || step.kind === "design" || step.kind === "pattern" || step.kind === "conclude";
      if (isChoiceKind && (!step.options || step.options.length === 0)) {
        errors.push(`stage "${stage.id}" step "${step.id}"（kind=${step.kind}）缺少 options`);
      }
      if (step.kind === "act" && (!step.requiredActions || step.requiredActions.length === 0)) {
        errors.push(`stage "${stage.id}" step "${step.id}"（kind=act）缺少 requiredActions`);
      }
      if (step.kind === "record" && (!step.recordFields || step.recordFields.length === 0)) {
        errors.push(`stage "${stage.id}" step "${step.id}"（kind=record）缺少 recordFields`);
      }
      if (step.kind === "knowledge" && (!step.knowledgeRefs || step.knowledgeRefs.length === 0)) {
        errors.push(`stage "${stage.id}" step "${step.id}"（kind=knowledge）缺少 knowledgeRefs`);
      }
      if (step.kind === "summary" && (!step.summaryItems || step.summaryItems.length === 0)) {
        errors.push(`stage "${stage.id}" step "${step.id}"（kind=summary）缺少 summaryItems`);
      }
      if (step.kind === "exam" && !step.exam) {
        errors.push(`stage "${stage.id}" step "${step.id}"（kind=exam）缺少 exam`);
      }
    }
  }

  return { valid: errors.length === 0, errors };
}
